import ArrowDown from './Icons/arrow-down.svg';
import ArrowLeft from './Icons/arrow-left.svg';
import ArrowRight from './Icons/arrow-right.svg';
import ArrowUp from './Icons/arrow-up.svg';
import BarSlider from './Icons/bar-slider.svg';
import BigCheck from './Icons/big-check.svg';
import BigClose from './Icons/big-close.svg';
import Calender from './Icons/calender.svg';
import CheckedBox from './Icons/checked-box.svg';
import CircleCheck from './Icons/circle-check.svg';
import Clock from './Icons/clock.svg';
import Close from './Icons/close.svg';
import CouponSmall from './Icons/coupon-small.svg';
import CreditCard from './Icons/credit-card.svg';
import DriverSeat from './Icons/driver-seat.svg';
import Driver from './Icons/driver.svg';
import Eye from './Icons/eye.svg';
import Fire from './Icons/fire.svg';
import GO24 from './Icons/go24.svg';
import HeaderPointer from './Icons/header-pointer.svg';
import History from './Icons/history.svg';
import Info from './Icons/info.svg';
import Lighning from './Icons/lighning.svg';
import LoginDestination from './Icons/login-destination.svg';
import LoginOrigin from './Icons/login-origin.svg';
import Passenger from './Icons/passenger.svg';
import Person from './Icons/person.svg';
import Plus from './Icons/plus.svg';
import PromotionTail from './Icons/promotion-tail.svg';
import Refresh from './Icons/refresh.svg';
import Report from './Icons/report.svg';
import SeatBooked from './Icons/seat-booked.svg';
import SeatLeft from './Icons/seat-left.svg';
import Seats from './Icons/seats.svg';
import SelectSeatSmall from './Icons/select-seat-small.svg';
import SelectSeatSmallest from './Icons/select-seat-smallest.svg';
import SelectSeat from './Icons/select-seat.svg';
import Sort from './Icons/sort.svg';
import StarOutline from './Icons/star-outline.svg';
import Swaper from './Icons/swaper.svg';
import TicketLine from './Icons/ticket-line.svg';
import Ticket from './Icons/ticket.svg';
import UncheckBox from './Icons/uncheck-box.svg';
import ViewMap from './Icons/view-map.svg';

import Slider1 from './Icons/slider/slider-1.svg';
import Slider2 from './Icons/slider/slider-2.svg';
import Slider3 from './Icons/slider/slider-3.svg';
import Slider4 from './Icons/slider/slider-4.svg';
import Slider5 from './Icons/slider/slider-5.svg';

import Rate1 from './Icons/rating/rate-1.svg';
import Rate2 from './Icons/rating/rate-2.svg';
import Rate3 from './Icons/rating/rate-3.svg';
import Rate4 from './Icons/rating/rate-4.svg';
import Rate5 from './Icons/rating/rate-5.svg';

import Default from './Icons/rating/default.svg';
import SmallRate1 from './Icons/rating/small-rate-1.svg';
import SmallRate2 from './Icons/rating/small-rate-2.svg';
import SmallRate3 from './Icons/rating/small-rate-3.svg';
import SmallRate4 from './Icons/rating/small-rate-4.svg';
import SmallRate5 from './Icons/rating/small-rate-5.svg';

export const Assets = {
  Header: require('./images/header.png'),
  Support: require('./images/support_image.png'),
  BusTicket: require('./images/bus_ticket.png'),
  VanTicket: require('./images/van_ticket.png'),
  Nham24Logo: require('./images/nham24_logo.png'),
  Bus: require('./images/bus.png'),
  Flight: require('./images/flight.png'),
  Ferry: require('./images/ferry.png'),
  TripDetailHeader: require('./images/trip_details_header.png'),
  InnerCircle: require('./images/timeline/inner_circle.png'),
  Circle: require('./images/timeline/circle.png'),
  DropOff: require('./images/timeline/drop_off.png'),
  DropOffPrimary: require('./images/drop_off_primary.png'),
  Ticket: require('./images/ticket.png'),
  RoundLeft: require('./images/left.png'),
  RoundRight: require('./images/right.png'),
  Nham24Icon: require('./images/nham24-icon.png'),
  Nham24IconGif: require('./images/nham24-icon-gif.gif'),

  TripEmpty: require('./images/empty/trip_empty.png'),
  HistoryEmpty: require('./images/empty/history_empty.png'),
  // TicketLine: require('./images/empty/ticket-line.png'),
};

export const Seat = {
  ChairSmall: require('./images/seat/chair-small.png'),
  ChairSelectedSmall: require('./images/seat/chair-selected-small.png'),
  ChairBusySmall: require('./images/seat/chair-busy-small.png'),
  ChairBookedSmall: require('./images/seat/chair-booked-small.png'),

  Chair: require('./images/seat/chair.png'),
  ChairSelected: require('./images/seat/chair-selected.png'),
  ChairBusy: require('./images/seat/chair-busy.png'),
  ChairBooked: require('./images/seat/chair-booked.png'),
};

export const PaymentAssets = {
  ABA: require('./images/payment/ABA.png'),
};

export const IconSvg = {
  Calender,
  History,
  LoginDestination,
  LoginOrigin,
  Passenger,
  Plus,
  Swaper,
  HeaderPointer,
  SeatLeft,
  Fire,
  SelectSeat,
  SelectSeatSmall,
  SelectSeatSmallest,
  DriverSeat,
  Eye,
  Info,
  CreditCard,
  ArrowRight,
  ArrowLeft,
  ArrowDown,
  ArrowUp,
  Close,
  CouponSmall,
  Ticket,
  BarSlider,
  CheckedBox,
  UncheckBox,
  Slider: {
    Slider1,
    Slider2,
    Slider3,
    Slider4,
    Slider5,
  },
  Rate: {
    Rate1,
    Rate2,
    Rate3,
    Rate4,
    Rate5,
    Default,
    SmallRate1,
    SmallRate2,
    SmallRate3,
    SmallRate4,
    SmallRate5,
  } as any,
  Person,
  StarOutline,
  Seats,
  Clock,
  Lighning,
  Driver,
  BigCheck,
  BigClose,
  Report,
  PromotionTail,
  Refresh,
  SeatBooked,
  CircleCheck,
  TicketLine,
  ViewMap,
  GO24,
  Sort,
};
